/**
 * Geomancer rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Tap → Play or draw a site. If you played an earth site, fill a
 *    void adjacent to you with Rubble.
 *    Tap → Replace an adjacent Rubble with the topmost site of your atlas."
 *
 * The first line is the universal avatar tap (Play / Draw) with a
 * triggered earth bonus (server-conjured on earth-site casts). The
 * second Tap is the `geomancer_replace_rubble` sidecar entry in
 * sorcery-cards-automation.json. The server-authoritative activated
 * ability, same pattern as Pathfinder. No builtin extra here: the old
 * `__builtin_geomancer_replace_rubble` duplicate resolved client-side
 * only, minting a phantom site the server had never heard of (GH-71).
 */
export const GEOMANCER_RULES = {};
